import Vue from 'vue'
import VueResource from 'vue-resource'
import CustomEvent from 'custom-event'
import api from 'src/config/api'
import _ from 'lodash'

Vue.use(VueResource)

const tableData = api.http.root + api.endpoints.table.base
const addressData = api.http.root + api.endpoints.address.base

const rendered = function (res) {
  let evt = new CustomEvent('rendered', { detail: res.data,
                                          bubbles: true,
                                          cancelable: false })
  setTimeout(function () { document.dispatchEvent(evt) }, 1000)
  return res
}

const submit = function () {
  let evt = new CustomEvent('submit', { detail: 'Ajax Submit Hook',
                                        bubbles: true,
                                        cancelable: false })
  document.dispatchEvent(evt)
}

const complete = function (res) {
  let evt = new CustomEvent('complete', { detail: res.data,
                                         bubbles: true,
                                         cancelable: false })
  setTimeout(function () { document.dispatchEvent(evt) }, 1000)
  return res
}

// Vue.http.options.crossOrigin = true
// Vue.http.options.xhr = {withCredentials: true}

// Vue.http.interceptors.push({});
// const resource = endpoint => Vue.resource(api.http.root + api.endpoints[endpoint])

// Resources
// -------------------------------
export const Workflows = {
  get (workflow, params, options) {
    return Vue.http.get(api.http.root + api.endpoints.newWorkflow + '/' + workflow, params, options).then(rendered)
  },
  escape (params, options) {
    return Vue.http.post(api.http.root + api.endpoints.escape, params, options).then(complete)
  },
  widget (params, options) {
    return Vue.http.get(api.http.root + api.endpoints.widget, params, options)
  }
}

export const AutoComplete = {
  get (id, params, options) {
    let url = _.template(api.http.root + api.endpoints.autocomplete + '/<%= id %>')
    return Vue.http.get(url({id}), params, options)
  }
}

export const Submit = {
  post (data, options) {
    submit()
    return Vue.http.post(api.http.root + api.endpoints.submit, data, options).then(rendered)
  }
}

export const Interrupt = {
  post (data, options) {
    return Vue.http.post(api.http.root + api.endpoints.interrupt, data, options)
  }
}

export const Auth = {
  login (credentials, options) {
    return Vue.http.post(api.http.root + api.endpoints.login, credentials, options)
  },
  logout (data, options) {
    return Vue.http.post(api.http.root + api.endpoints.login, data, options)
  }
}

export const DataTable = {
  page (params, options) {
    return Vue.http.post(tableData + api.endpoints.table.page, params, options)
  },
  expander (params, options) {
    return Vue.http.post(tableData + api.endpoints.table.expander, params, options)
  },
  download (params, options) {
    return Vue.http.get(tableData + api.endpoints.table.download, params, options)
  },
  html (params, options) {
    return Vue.http.post(api.http.root + api.endpoints.table.html, params, options)
  }
}

export const Data = {
  pdf (params, options) {
    return Vue.http.get(api.http.root + api.endpoints.data.pdf, params, options)
  }
}

export const Address = {
  find (params, options) {
    return Vue.http.post(addressData + api.endpoints.address.search, params, options)
  },
  fetch (params, options) {
    return Vue.http.post(addressData + api.endpoints.address.lookup, params, options)
  }
}

export const Asset = {
  upload: (params, opts) => Vue.http.post(api.http.root + '/action/asset/upload', params, opts),
  get: (params, opts) => Vue.http.get(api.http.root + '/action/asset/upload', params, opts)
}



// WEBPACK FOOTER //
// ./src/services/resources.js